import type React from "react";
import type { ButtonSize, ButtonVariant } from "@/components/button";

export interface ButtonLinkProps extends React.ComponentProps<"a"> {
	variant?: ButtonVariant;
	size?: ButtonSize;
}

// An anchor that looks like a Button (shares the `button` slot styles).
export function ButtonLink({
	variant = "default",
	size = "default",
	...props
}: ButtonLinkProps) {
	return (
		<a data-slot="button" data-variant={variant} data-size={size} {...props} />
	);
}
